import React from 'react';

export type PulseMarkerProps = {
  /** SVG x-coordinate (user units) of the marker centre. */
  x: number;
  /** SVG y-coordinate (user units) of the marker centre. */
  y: number;
  variant: 'queued' | 'proposed' | 'manual';
  /** Optional radius override (CSS px). Default 7. */
  size?: number;
};

/**
 * Animated marker: a steadily-pulsing core with an outward expanding halo.
 * Rendered as inline HTML (absolutely-positioned div) so the CSS keyframes
 * in animations.css drive the animation. If you want an SVG-native version
 * (nested inside <svg>), use `PulseMarkerSvg` further down.
 */
export const PulseMarker: React.FC<PulseMarkerProps> = ({ x, y, variant, size = 7 }) => {
  const variantClass =
    variant === 'queued'
      ? 'as-pulse-queued'
      : variant === 'proposed'
        ? 'as-pulse-proposed'
        : 'as-pulse-manual';
  const dim = size * 2;
  return (
    <div
      className={`as-pulse-marker ${variantClass}`}
      style={{
        left: x - size,
        top: y - size,
        width: dim,
        height: dim,
        position: 'absolute',
      }}
      aria-hidden="true"
    >
      <span className="as-pulse-halo" />
      <span className="as-pulse-core" />
    </div>
  );
};
